<template>
    <el-form :model="form" :rules="rules" ref="form" label-width="150px">
      <el-row type="flex" justify="start" align="top">
        <el-form-item label="系统可使用期限" prop="">
          <el-date-picker
              style="width: 140px"
              v-model="form.openTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
          <div style="width:40px;line-height:30px;display:inline-block;text-align: center;">起</div>
          <el-input-number style="width: 120px" v-model="form.useYear" @change="handleUseYearChange" :value="1"
                           :min="1" :max="10" label="年份"></el-input-number>
          年，至<span>{{ endTimeStr }}</span>
          &ensp;<el-checkbox v-model="form.isNotify" @change=""></el-checkbox>
          <span>&nbsp;到期前3个月每次登录报警提示续费</span>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="start" align="top">
        <el-form-item label="收费按照" prop="chargeType" required>
          <el-radio v-model="form.chargeType" label="0" style="width:100px" @change="feeHandler">每年</el-radio>
        </el-form-item>
        <el-form-item label-width="0" prop="yearFee" required>
          <el-input v-model="form.yearFee"  placeholder="请输入" style="width: 122px;"></el-input>&emsp;元
        </el-form-item>
      </el-row>
      <!--<el-row type="flex" justify="start" align="top">-->
        <!--<el-form-item label="" prop="">-->
          <!--<el-radio v-model="form.chargeType" label="1" style="width:100px" @change="v=>form.yearFee=''">每升油</el-radio>-->
          <!--<el-input v-model="form.oilLiterPrice" placeholder="请输入" style="width: 122px;"></el-input>&emsp;元-->
          <!--（使用期限内，-->
          <!--<el-radio v-model="form.isCapping" label="0">不封顶</el-radio>-->
          <!--<el-radio v-model="form.isCapping" label="1">封顶</el-radio>-->
          <!--<el-input v-model="form.onlineCost" placeholder="请输入" style="width: 15%"></el-input>-->
          <!--元）-->

        <!--</el-form-item>-->
      <!--</el-row>-->
      <el-row style="padding-top:20px;">
        <div class="dialog-footer" style="padding-left: 40%">
          <el-button @click="closeDialog()" size="small">关 闭</el-button>
          <el-button size="small" type="primary" @click="enterpriseServiceOpen('form')">确 定</el-button>
        </div>
      </el-row>
    </el-form>
</template>

<script>

import {mapGetters} from 'vuex';
import {openEnterprise, uploadFile,againOpen} from '@/api/admin/sysEnterprise/index';
export default {
  name: "entService",
  props:["entId","openTime"],
  data() {
    return {
      form: {
          entId : null,
          openId : null,
          chargeType : null,
          useYear: 1,
          yearFee : null,
          oilLiterPrice : null,
          isCapping : null,
          onlineCost : null,
          openTime : null,
          auditTime : null,
          applyTime : null,
          auditName : null,
          userId : null,
          status : null,
      },
        rules: {
            chargeType: [
                {
                    required: true,
                    message: '请选择',
                    trigger: 'blur'
                }
            ],yearFee: [
                {
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                }
            ],
        }
    }
  },
  mounted() {
  },
  computed: {
      endTimeStr:function(){
        if(!this.form.openTime){
              return "";
        }
        let date = new Date(this.form.openTime.replace(/-/g, "/"));
        date.setYear(date.getFullYear()+this.form.useYear);
        return date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日";;
    },
    ...mapGetters([
      'elements'
    ])
  },
  created() {
      if(!this.openTime) {
          let date = new Date();
          this.form.openTime = date.getFullYear() + "-" + this.padStart(date.getMonth() + 1,2,'0') + "-" + this.padStart(date.getDate(),2,'0');
      }
      if(this.entId){
          this.form.entId= this.entId;
      }
  },
  methods: {
      feeHandler:function(v){
          this.form.isCapping = 0;
          this.form.oilLiterPrice = "";
          this.form.onlineCost = "";
      },
      enterpriseServiceOpen(formName){
          const set = this.$refs;
          set[formName].validate(valid => {
              if (valid) {
                  openEnterprise({...this.form, openTime: this.form.openTime, isCapping: this.form.isCapping=='1'?true:false}).then(result => {
                      this.$notify({
                          title: '成功',
                          message: '开通申请成功',
                          type: 'success',
                          duration: 2000
                      });
                      this.$emit('success')
                  }).catch(err=>{
                      this.$notify.error({
                          title: '错误',
                          message: err.message
                      });
                  });
              } else {
                  return false;
              }
          });
      } ,
      padStart:function(s, minLen, c){
          s+='';
          if(s.length<minLen){
              return [...Array(minLen-s.length).keys()].reduce((str,v)=>str=c+str, s);
          }
          return s;
      },
      closeDialog(){
          this.$emit('close')
      }
  }
}
</script>
<style>
.el-form-item {
  margin-bottom: 5px;
}
</style>